<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,}
    },
  watch: {
    $route(to, form) {
      if (to.fullPath != "/") {
        this.axios
          .get(this.serve+"/admin/admin_is_login", {
            params: {
              username: this.$cookies.get("username"),
              token: this.$cookies.get("token")
            }
          })
          .then(res => {
            if (res.data == 1) {
              // next();
            } else {
              this.$confirm("您的登录信息已过期,需重新登录", "登录提示", {
                confirmButtonText: "去登陆",
                cancelButtonText: "留在此页",
                type: "warning"
              })
                .then(() => {
                  this.$router.push("/");
                })
                .catch(() => {
                });
            }
          });
      }
    }
  }
};
</script>
<style lang="scss">
a {
  text-decoration: none;
}
.bread {
  padding: 20px 0;
  color: #999;
}
</style>